import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import swal from 'sweetalert2';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import addModal from '../../../utils/state/react_modals';

const uCaseFirst = (word) => {
    if (word === undefined || word === 'undefined') {
        return 'Unknown';
    }

    return `${word.slice(0, 1).toUpperCase()}${word.slice(1)}`;
}

let askAboutCheckInEdit = true;

const ParticipantEditModal = observer(props => {
    const { participant, close, confirm } = props;

    return (
        <Modal
            isOpen={true}
            onClosed={confirm}
            onExit={confirm}
            toggle={confirm}
            className="no-print"
            backdropClassName="no-print"
            modalClassName="no-print"
            wrapClassName="no-print">
            <ModalHeader toggle={confirm}>Edit {participant.first_name} {participant.last_name}</ModalHeader>
            <ModalBody>
                <div className="row mb-1">
                    <div className="col-3 control-label">
                        First Name:
                    </div>
                    <div className="col-9">
                        <input
                            type="text"
                            className="form-control"
                            value={participant.first_name}
                            onChange={(e) => participant.first_name = e.currentTarget.value} />
                    </div>
                </div>
                <div className="row mb-1">
                    <div className="col-3 control-label">
                        Last Name:
                    </div>
                    <div className="col-9">
                        <input
                            type="text"
                            className="form-control"
                            value={participant.last_name}
                            onChange={(e) => participant.last_name = e.currentTarget.value} />
                    </div>
                </div>
                <div className="row mb-1">
                    <div className="col-3 control-label">
                        Email (School):
                    </div>
                    <div className="col-9">
                        <input
                            type="text"
                            className="form-control"
                            value={participant.email}
                            onChange={(e) => participant.email = e.currentTarget.value} />
                    </div>
                </div>
                <div className="row mb-1">
                    <div className="col-3 control-label">
                        Email (Home):
                    </div>
                    <div className="col-9">
                        <input
                            type="text"
                            className="form-control"
                            value={participant.email_second}
                            onChange={(e) => participant.email_second = e.currentTarget.value} />
                    </div>
                </div>
                <div className="row mb-1">
                    <div className="col-9 offset-3 control-label">
                        <input
                            type="checkbox"
                            className="form-control mr-1"
                            id="is-outside-participant"
                            disabled={participant.registration_id > 0}
                            checked={participant.is_outside_participant}
                            onChange={() => participant.is_outside_participant = !participant.is_outside_participant} />
                        <label htmlFor="is-outside-participant">Outside Participant (not a host registration)</label>
                        {participant.registration_id > 0 ? (
                            <div className="help-text text-info">
                                Outside Registration status cannot be changed because this participant registered before the event.
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className="row mb-1">
                    <div className="col-9 offset-3 control-label">
                        <input
                            type="checkbox"
                            className="form-control mr-1"
                            id="gave-special-invite"
                            disabled={participant.registration_id > 0}
                            checked={participant.sent_special_invite}
                            onChange={() => participant.sent_special_invite = !participant.sent_special_invite} />
                        <label htmlFor="gave-special-invite">Special Invitation (gave flyer)</label>
                        <div className="help-text text-info">
                            If you identified this participant as having what it takes to be an Associate Trainer, hand them the
                             special invitation flyer and select this option to let the office know.
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <button type="button" onClick={() => participant.save() && confirm()} className="btn btn-primary btn-block btn-lg mr-1">
                    Continue
                </button>
            </ModalFooter>
        </Modal>
    );
});

const ParticipantRow = observer(
    class ParticipantRow extends React.Component {
        checkInOutParticipant(d) {
            const { participant } = this.props;
            const is_checked_in = participant.checkins.indexOf(d.to_s) >= 0;

            if (is_checked_in) {
                if (askAboutCheckInEdit) {
                    swal({
                        title: 'Remove Check-In?',
                        text: `Remove check-in on ${d.for_header} for ${participant.full_name}?`,
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Remove Check-In',
                        cancelButtonText: 'Cancel',
                        input: 'checkbox',
                        inputValue: 0,
                        inputPlaceholder: "Don't ask again",
                    }).then(({ value, dismiss }) => {
                        if (!dismiss) {
                            participant.remove_check_in(d);

                            if (value) {
                                askAboutCheckInEdit = false;
                            }
                        }
                    });
                } else {
                    participant.remove_check_in(d);
                }
            } else {
                if (askAboutCheckInEdit) {
                    swal({
                        title: 'Add Check-In?',
                        text: `Add check-in on ${d.for_header} for ${participant.full_name}?`,
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Add Check-In',
                        cancelButtonText: 'Cancel',
                        input: 'checkbox',
                        inputValue: 0,
                        inputPlaceholder: "Don't ask again",
                    }).then(({ value, dismiss }) => {
                        if (!dismiss) {
                            participant.check_in(d);

                            if (value) {
                                askAboutCheckInEdit = false;
                            }
                        }
                    });
                } else {
                    participant.check_in(d);
                }
            }
        }

        showEditModal = (e) => {
            e.preventDefault();
            this.props.participant.is_editing = true;
            addModal((close, confirm) => (
                <ParticipantEditModal participant={this.props.participant} close={close} confirm={confirm} />
            )).then(() => {
                this.props.participant.is_editing = false;
            });
        }

        render() {
            const { participant, event } = this.props;
            const { registration_status } = participant;

            const className = registration_status && registration_status.toLowerCase() == 'pending'
                ? 'bg-warning border-warning font-weight-bold' : null;

            return (
                <tr className={className}>
                    <td>
                        <a href="#" onClick={this.showEditModal}>
                            {participant.last_name}, {participant.first_name}
                        </a>
                        {participant.is_outside_participant ? <div className="badge badge-dark ml-1">Outside</div> : null}
                        {participant.status !== 'active' ? <div className="badge badge-danger ml-1">{uCaseFirst(participant.status)}</div> : null}
                        {participant.sent_special_invite ? <div className="badge badge-info ml-2">Invited</div> : null}
                        {participant.registration_status == 'pending' ? (
                            <div className="help-text"><em>Registration Pending</em></div>
                        ) : null}
                    </td>
                    {event.days.map(d => (
                        <td key={`${participant.uuid}-${d.to_s}`} className={ `text-center ${d.is_today ? 'bg-light border-right border-left' : ''}` }>
                            <i onClick={() => this.checkInOutParticipant(d)}
                                className={ `h3 p-0 m-0 ${participant.checkins.indexOf(d.to_s) >= 0 ? 'fa fa-check-circle text-success' : 'far text-muted fa-circle'}` } />
                        </td>
                    ))}
                </tr>
            );
        }
    }
);

const TableHead = observer(props => {
    const { counts_by_day_by_group } = props.event;
    const counts_by_day = counts_by_day_by_group[props.group];

    return (
        <thead style={{ position: 'sticky', top: 0 }}>
            <tr>
                <th className="bg-light">{uCaseFirst(props.group)} Participants</th>
                {props.event.days.map(d => (
                    <th key={`day-${d.to_s}`}
                        className="text-center bg-light text-nowrap cursor-pointer"
                        onClick={() => props.event.checkInAll(d, props.group)}>
                        <div>
                            {d.for_header}
                        </div>
                        <div>{counts_by_day[d.to_s] ? counts_by_day[d.to_s].length : 0} of {counts_by_day.total}</div>
                    </th>))}
            </tr>
        </thead>
    );
});

const TableBody = observer(props => {
    const { participants_by_group } = props.event;

    const participants = participants_by_group[props.group].map(p => (
        <ParticipantRow key={p.uuid} {...props} participant={p} />
    ));

    return (
        <tbody>
            {participants}
        </tbody>
    );
});

export default observer(props => {
    const { participant_groups, knet_id, can_register, total_unique_registrations } = props.event;

    return (
        <div>
            <div className="d-flex no-print">
                <div className="flex-fill font-weight-bold text-success">
                    {total_unique_registrations} Participant{total_unique_registrations === 1 ? ' Has' : 's Have'} Checked In
                </div>
                <div className="text-right pb-2 no-print">
                    {can_register ? (
                        <a href={`/workshops/check-in/${knet_id}/`}>
                            Register A Participant
                        </a>
                    ) : <span className="text-danger">Registration Is Closed For This Event</span>}
                </div>
            </div>
            <table className="table table-striped">
                {participant_groups.map(group => (
                    <Fragment key={group}>
                        <TableHead group={group} {...props} />
                        <TableBody group={group} {...props} />
                    </Fragment>
                ))}
            </table>
            {props.event.has_deleted_participants ? (
                <div className="my-2 text-right no-print">
                    <button className="btn btn-default" onClick={() => props.event.show_deleted = !props.event.show_deleted}>
                        {props.event.show_deleted ? 'Hide' : 'Show'} Deleted Registrations
                    </button>
                </div>
            ) : null}
        </div>
    );
});
